import { Box, Card, Grid, Typography } from "@material-ui/core"
import { MultiContratoModel } from "api/touchone/models/multi-contrato"
import React from "react"
import { formatarCPFCNPJ } from "utils/cpfcnpj-format"
import { useStyles } from "./card-contrato-styles"
import { PessoaIcon } from "components/icons/pessoa-icon"
import { AvancarIcon } from "components/icons/avancar-icon"
import classNames from "classnames"

export type CardContratoProps = {
    model: MultiContratoModel
    onClick: (contratoId: string) => void
    selecionado?: boolean
}

export const CardContrato = ({ model, onClick, selecionado }: CardContratoProps) => {
    const classes = useStyles();
    return (
        <Card className={classNames(classes.card, selecionado && classes.selecionado)} onClick={() => onClick(model.contratoId)}>
            <Box p={2}>
                <Grid container spacing={2}>
                    <Grid item xs={"auto"}>
                        <Box display="flex" alignItems="center" height={"100%"}>
                            <PessoaIcon tipo="BUTTON" class={classes.icon} />
                        </Box>
                    </Grid>
                    <Grid item xs>
                        <Box>
                            <Typography variant="body1" color="primary" className={classes.negrito}>
                                {model.nome}
                            </Typography>
                            <Typography variant="body2">
                                {formatarCPFCNPJ(model.cNPJ)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs="auto">
                        <Box display="flex" alignItems="center" height={"100%"}>
                            <AvancarIcon tipo="BUTTON" class={classes.icon} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    )
}